import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Code',
    field: 'code',
    component: inputTextField({ req: true, max: 31 }),
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    // type: 'text',
    component: inputTextField({ req: true })
  }),
  // createColumn({
  //   label: 'Parent ID',
  //   field: 'parentId',
  //   type: 'number',
  //   // component: inputTextField({ type: 'number', req: false, max: 10, money: true })
  //   defaultValue: null,
  //   clearValue: null
  // }),
  createColumn({
    label: 'Parent',
    field: 'parent',
    ...relationField({
      type: 'one',
      namespace: 'csiCodes',
      localKey: 'parentId',
      fk: 'id',
      label: 'description',
      nested: true,
      parentRestraint: true,
      // searchColumns: ['description', 'code'],
      filterIs: 'select-one-field',
      // props: { allowEdit: false }
      validation: {
        required: true
      },
    })
  }),
].concat(defaultColumns)
